module.exports = __webpack_public_path__ + "static/media/book-icon-mobile.4e3d6eb0.svg";